export default __webpack_public_path__ + "static/media/hht1_ep04_timeline_q01_a.b4b11296.png";